module.exports = __webpack_public_path__ + "img/swiper2.96624033.png";